import React, { createContext, useState, useContext, ReactNode } from 'react';

interface LoadingContextProps {
	isLoading: boolean;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const LoadingContext = createContext<LoadingContextProps | undefined>(
	undefined,
);

interface LoadingProviderProps {
	children: ReactNode;
}

/**
 * Provider for the Loading context.
 * Usage: Already wrapped in the App component. Simply use the useLoading hook to access the context.
 * Example: If you want to show a loading spinner when a request is being made, you can use the useLoading hook to set the isLoading state to true when the request is being made and false when the request is completed.
 * @param param0
 * @returns
 */
export const LoadingProvider: React.FC<LoadingProviderProps> = ({
	children,
}) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		<LoadingContext.Provider value={{ isLoading, setIsLoading }}>
			{children}
		</LoadingContext.Provider>
	);
};

export const useLoading = (): LoadingContextProps => {
	const context = useContext(LoadingContext);
	if (!context) {
		throw new Error('useLoading must be used within a LoadingProvider');
	}
	return context;
};
